<template>
  <div class="animated fadeIn">
    <div class="alert alert-danger" v-if="synchroDates && !synchroDates[1]._isActual">
      Brak połączenia z obiektem Malinowy Zdrój. Dane nie są aktualne.
    </div>
    <div class="alert alert-danger" v-if="synchroDates && !synchroDates[2]._isActual">
      Brak połączenia z obiektem Malinowy Raj. Dane nie są aktualne.
    </div>
    <div class="alert alert-danger" v-if="synchroDates && !synchroDates[3]._isActual">
      Brak połączenia z obiektem Malinowy Dwór. Dane nie są aktualne.
    </div>
    <div class="row">
      <div class="col-sm-6 col-md-2" v-if="clients">
        <div class="card">
          <div class="card-body">
            <div class="h1 text-muted text-right mb-4"><i class="icon-people"></i></div>
            <div class="h4 mb-0">{{ clients }}</div>
            <small class="text-muted text-uppercase font-weight-bold">Klientów</small>
            <div class="progress-xs mt-3 mb-0 progress">
              <div class="progress-bar bg-info" style="width: 25%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-2" v-if="applicableLoyaltyCards">
        <div class="card">
          <div class="card-body">
            <div class="h1 text-muted text-right mb-4"><i class="icon-credit-card"></i></div>
            <div class="h4 mb-0">{{ applicableLoyaltyCards }}</div>
            <small class="text-muted text-uppercase font-weight-bold">Kart do wydania</small>
            <div class="progress-xs mt-3 mb-0 progress">
              <div class="progress-bar bg-success" style="width: 25%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-2" v-if="loyaltyCards.total">
        <div class="card">
          <div class="card-body">
            <div class="h1 text-muted text-right mb-4"><i class="icon-credit-card"></i></div>
            <div class="h4 mb-0">{{ loyaltyCards.total }}</div>
            <small class="text-muted text-uppercase font-weight-bold">Kart wydanych</small>
            <div class="progress-xs mt-3 mb-0 progress">
              <div class="progress-bar bg-warning" style="width: 25%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-2" v-if="manualSync !== null">
        <div class="card">
          <div class="card-body">
            <div class="h1 text-muted text-right mb-4"><i class="icon-cloud-upload"></i></div>
            <div class="h4 mb-0">{{ manualSync }}</div>
            <small class="text-muted text-uppercase font-weight-bold">Do zatwierdzenia</small>
            <div class="progress-xs mt-3 mb-0 progress">
              <div class="progress-bar bg-info" style="width: 25%;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="hasInvoices">
      <div class="card">
        <div class="card-body">
          <canvas id="myChart" width="400" height="150"></canvas>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-lg-4" v-show="hasMeldunki">
        <div class="card">
          <div class="card-body">
            <canvas id="meldunkiChart" width="200" height="150"></canvas>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4" v-show="hasMonthInvoices">
        <div class="card">
          <div class="card-body">
            <canvas id="monthInvoicesChart" width="200" height="150"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import statsService from '../services/statsService';
  import * as Chart from 'chart.js';
  import Decimal from 'decimal.js';
  import moment from 'moment';

  export default {
    components: {},
    data: function () {
      return {
        clients: null,
        synchroDates: null,
        loyaltyCards: {},
        applicableLoyaltyCards: null,
        manualSync: null,
        hasInvoices: false,
        hasMeldunki: false,
        hasMonthInvoices: false,
      };
    },
    mounted: function () {
      statsService.getStats()
        .then(r => {
          this.clients = r.clients || 0;
          this.synchroDates = {
            ...this.parseSynchroDates(r.synchroDates),
          };
          this.applicableLoyaltyCards = r.applicableLoyaltyCards || 0;
          this.manualSync = r.manualSync || 0;
          this.loyaltyCards = r.loyaltyCards || {};
          this.hasInvoices = !!r.invoices;
          this.hasMeldunki = !!r.meldunki;
          this.hasMonthInvoices = !!r.monthInvoices;
          Chart.scaleService.updateScaleDefaults('bar', {
            ticks: {
              min: 0
            }
          });
          this.makeInvoicesChart(r);
          this.makeMeldunkiChart(r);
          this.makeMonthInvoicesChart(r);
        });
    },
    methods: {
      parseSynchroDates: function (synchroDates) {
        const lastSynchroWanted = moment(synchroDates._lastSynchro);
        [1, 2, 3].forEach(key => {
          synchroDates[key]._isActual = true;
          Object.keys(synchroDates[key]).forEach(type => {
            if (type === '_isActual') return;
            synchroDates[key]._isActual = synchroDates[key]._isActual &&
              moment(synchroDates[key][type]).isSame(lastSynchroWanted, 'day');
          });
        });
        return synchroDates;
      },
      makeInvoicesChart: function (r) {
        if (!r.invoices) {
          return;
        }
        const invoices = {
          1: [],
          2: [],
          3: [],
        };
        const labels = new Array(...new Set(r.invoices.map(i => i.invoice_date)));
        labels.forEach((label) => {
          invoices[1].push((r.invoices.find(i => i.branch_id === 1 && i.invoice_date === label) || {}).totalNet || 0);
          invoices[2].push((r.invoices.find(i => i.branch_id === 2 && i.invoice_date === label) || {}).totalNet || 0);
          invoices[3].push((r.invoices.find(i => i.branch_id === 3 && i.invoice_date === label) || {}).totalNet || 0);
        });
        var ctx = document.getElementById('myChart');
        new Chart(ctx, {
          type: 'bar',
          // The data for our dataset
          data: {
            labels: labels
              .map(value => {
                let parsedValue;
                try {
                  parsedValue = moment(value).format('DD.MM.YYYY');
                } catch (e) {
                  parsedValue = value;
                }
                return parsedValue;
              }),
            datasets: [
              {
                label: 'Malinowy Zdrój',
                backgroundColor: '#006dbf',
                borderColor: '#006dbf',
                data: invoices[1],
              },
              {
                label: 'Malinowy Raj',
                backgroundColor: '#39b54a',
                borderColor: '#39b54a',
                data: invoices[2],
              },
              {
                label: 'Malinowy Dwór',
                backgroundColor: '#ba2d65',
                borderColor: '#ba2d65',
                data: invoices[3],
              }
            ]
          },

          // Configuration options go here
          options: {
            tooltips: {
              mode: 'index',
              callbacks: {
                label: function (tooltipItem, data) {
                  var label = data.datasets[tooltipItem.datasetIndex].label || '';

                  if (label) {
                    label += ': ';
                  }
                  let parsedValue;
                  try {
                    parsedValue = new Decimal(tooltipItem.yLabel).toFixed(2);
                    const arr = parsedValue.split('.');
                    const b = arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                    parsedValue = `${b} PLN`;
                  } catch (e) {
                    parsedValue = tooltipItem.yLabel;
                  }
                  return `${label} ${parsedValue}`;
                }
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  // Include a dollar sign in the ticks
                  callback: function (value) {
                    let parsedValue;
                    try {
                      parsedValue = new Decimal(value).toFixed(2);
                      const arr = parsedValue.split('.');
                      const b = arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                      parsedValue = `${b} PLN`;
                    } catch (e) {
                      parsedValue = value;
                    }
                    return parsedValue;
                  },
                  min: 0,
                },
              }]
            }
          }
        });
      },
      makeMeldunkiChart: function (r) {
        if (!r.meldunki) {
          return;
        }
        const meldunki = {};
        r.meldunki.forEach(i => {
          meldunki[i.branch_id] = [i.amount];
        });
        var ctx = document.getElementById('meldunkiChart');
        new Chart(ctx, {
          type: 'bar',
          // The data for our dataset
          data: {
            labels: ['']
            ,
            datasets: [
              {
                label: 'Malinowy Zdrój',
                backgroundColor: '#006dbf',
                borderColor: '#006dbf',
                data: meldunki[1]
              },
              {
                label: 'Malinowy Raj',
                backgroundColor: '#39b54a',
                borderColor: '#39b54a',
                data: meldunki[2]
              },
              {
                label: 'Malinowy Dwór',
                backgroundColor: '#ba2d65',
                borderColor: '#ba2d65',
                data: meldunki[3]
              }
            ]
          },

          // Configuration options go here
          options: {
            title: {
              display: true,
              text: 'Liczba aktualnych meldunków',
            },
            scales: {
              yAxes: [{
                ticks: {
                  min: 0,
                },
              }]
            }
          }
        });
      },
      makeMonthInvoicesChart: function (r) {
        if (!r.monthInvoices) {
          return;
        }
        const monthInvoices = {};
        r.monthInvoices.forEach(i => {
          monthInvoices[i.branch_id] = [i.totalNet];
        });
        var ctx = document.getElementById('monthInvoicesChart');
        new Chart(ctx, {
          type: 'bar',
          // The data for our dataset
          data: {
            labels: ['']
            ,
            datasets: [
              {
                label: 'Malinowy Zdrój',
                backgroundColor: '#006dbf',
                borderColor: '#006dbf',
                data: monthInvoices[1]
              },
              {
                label: 'Malinowy Raj',
                backgroundColor: '#39b54a',
                borderColor: '#39b54a',
                data: monthInvoices[2]
              },
              {
                label: 'Malinowy Dwór',
                backgroundColor: '#ba2d65',
                borderColor: '#ba2d65',
                data: monthInvoices[3]
              }
            ]
          },

          // Configuration options go here
          options: {
            title: {
              display: true,
              text: 'Obrót netto od początku miesiąca',
            },
            tooltips: {
              mode: 'index',
              callbacks: {
                label: function (tooltipItem, data) {
                  var label = data.datasets[tooltipItem.datasetIndex].label || '';

                  if (label) {
                    label += ': ';
                  }
                  let parsedValue;
                  try {
                    parsedValue = new Decimal(tooltipItem.yLabel).toFixed(2);
                    const arr = parsedValue.split('.');
                    const b = arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                    parsedValue = `${b} PLN`;
                  } catch (e) {
                    parsedValue = tooltipItem.yLabel;
                  }
                  return `${label} ${parsedValue}`;
                }
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  // Include a dollar sign in the ticks
                  callback: function (value) {
                    let parsedValue;
                    try {
                      parsedValue = new Decimal(value).toFixed(2);
                      const arr = parsedValue.split('.');
                      const b = arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                      parsedValue = `${b} PLN`;
                    } catch (e) {
                      parsedValue = value;
                    }
                    return parsedValue;
                  },
                  min: 0,
                },
              }]
            }
          }
        });
      }
    }
  };
</script>

<style>

</style>
